import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { GroupEditRequestBody, GroupEditResponse } from "./types";

export class GroupEditAPI extends BaseAPI<
  GroupEditRequestBody,
  GroupEditResponse
> {
  protected route = ApiRoutes.group.edit;
  protected method = RequestMethod.POST;
  protected params = ["groupId"];
}
